/* eslint-disable */
import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { useSubscription } from "@apollo/client";
import { MESSAGE_USER_SUB } from "../gql/mutations/auth";
import { deleteLocalTokens, saveLocalTokens, saveSessionTokens } from "../utils/session";
import { LocalStorageKey } from "../common/constant";

const UseRefreshToken = async tokens => {
  try {
    const response = await fetch(`${process.env.REACT_APP_BACKEND_URI}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${tokens.refreshToken}`,
      },
      body: JSON.stringify({
        query: `
          mutation RefreshToken {
            refreshToken {
              accessToken
              refreshToken
            }
          }
        `,
      }),
    });

    if (!response.ok) {
      throw new Error("Failed to refresh token");
    }

    const result = await response.json();

    const { accessToken, refreshToken } = result.data.refreshToken;

    if (sessionStorage.getItem(LocalStorageKey.REFRESH_TOKEN)) {
      saveSessionTokens({
        accessToken,
        refreshToken,
      });
    } else {
      saveLocalTokens({
        accessToken,
        refreshToken,
      });
    }

    return accessToken;
  } catch (err) {
    deleteLocalTokens();
    throw err;
  }
};

const useSubscriptionCall = async () => {
  const [data, setData] = useState({});
  const { email } = useSelector(state => state.reducer.userData);

  async function getData() {
    try {
      const { data: resData } = await useSubscription(MESSAGE_USER_SUB, {
        variables: { email },
      });
      setData(resData);
    } catch (err) {
      // console.log(err);
    }
  }

  useEffect(() => {
    if (email) {
      getData();
    }
  }, [email]);

  return { data };
};

export { UseRefreshToken, useSubscriptionCall };
